<ng-content select=".message" />
<form data-test="login-form" novalidate [formGroup]="form">
	<fieldset>
		@if (!hasOrganisation) {
			<pv-input
				autocomplete="on"
				data-test="organisation-input"
				formControlName="organisation"
				icon="fa fa-building"
				label="{{ 'general.titles.organisation' | translate }}"
				placeholder="{{ 'general.titles.organisation' | translate }}"
				type="text"
				[class.error]="invalidOrganisation"
			>
				@if (invalidOrganisation) {
					<p class="errors">{{ "labels.error.required" | translate }}</p>
				}
			</pv-input>
		}

		<pv-input
			autocomplete="on"
			data-test="user-input"
			formControlName="username"
			icon="fa fa-user"
			label="{{ 'auth.username' | translate }}"
			placeholder="{{ 'auth.username' | translate }}"
			type="text"
			[class.error]="invalidUsername"
		>
			@if (invalidUsername) {
				<p class="errors">{{ "labels.error.required" | translate }}</p>
			}
		</pv-input>

		<pv-input
			autocomplete="on"
			data-test="password-input"
			formControlName="password"
			icon="fa fa-lock"
			label="{{ 'auth.password' | translate }}"
			placeholder="{{ 'auth.password' | translate }}"
			type="password"
			[class.error]="invalidPassword"
		>
			@if (invalidPassword) {
				<p class="errors">{{ "labels.error.required" | translate }}</p>
			}
		</pv-input>
		<div class="button">
			<ui-button
				data-test="signin-button"
				[disabled]="loading"
				[icValidateForms]="[form]"
				[loading]="loading"
				(confirm)="submit()"
				>{{ "auth.signin" | translate }}</ui-button
			>
		</div>
	</fieldset>
</form>
